import './App.css';
import { Route, Routes } from "react-router-dom";
import Login from "./components/auth/Login";
import axios from "axios";
import { Unauthorized } from "./components/helper/HelperTwo";
import { ProtectedRoute } from "./components/helper/HelperOne";
import Customer from "./components/admin/customer/Customer";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ForgetPassword from './components/auth/ForgetPassword';
import ResetPassword from './components/auth/ResetPassword';
import TaskPriority from './components/admin/Masters/TaskPriority/TaskPriority';
import Maintenance from './components/admin/Maintenance';
import Lead from './components/admin/LeadManagement/Lead';
import LeadDashboard from './components/admin/LeadDashboard/LeadDashboard';
import LeadTask from './components/admin/LeadTask/LeadTask';
import AllLeadTask from './components/admin/AllLeadTask/AllLeadTask';
import Status from './components/admin/Masters/Status/Status';
import LeadSource from './components/admin/Masters/LeadSource/LeadSource';
import DiscussionStatus from './components/admin/Masters/DiscussionStatus/DiscussionStatus';
import Quotation from './components/admin/Quotation/Quotation';
import LeadEmployees from './components/admin/LeadEmployees/LeadEmployees';
import LeadRole from './components/admin/LeadRoles/LeadRole';
import LeadRoleAssign from './components/admin/LeadRoleAssign/LeadRoleAssign';
import QuotationStatus from './components/admin/Masters/QuotationStatus/QuotationStatus';
import TaskStatus from './components/admin/Masters/TaskStatus/TaskStatus';
import LeadBranch from './components/admin/Masters/LeadBranch/LeadBranch';
import LeadProducts from './components/admin/LeadProducts/LeadProducts';
import EmployeeWorkRelated from './components/admin/EmployeeWorkRelated/EmployeeWorkRelated';
import ProductwiseReport from './components/admin/ProductwiseReport/ProductwiseReport';
import TypeOfWork from './components/admin/Masters/TypeOfWork/TypeOfWork';

// axios.defaults.baseURL = 'https://leads.dreamsdigitall.in/api/1';
axios.defaults.baseURL = 'https://leadsv1.dreamsdigitall.in/api/1';
// axios.defaults.baseURL = 'http://localhost/pradeep/laravel/lleads/';


function App() {

  const user = JSON.parse(localStorage.getItem('user'));
  const customerPermission = user?.customer_role_based_access?.some(
    (access) => access.label_id == 1 && access.label_value != 0
  );
  const employeePermission = user?.employee_role_based_access?.some(
    (access) => access.label_id == 1 && access.label_value != 0
  );
  const leadPermission = user?.lead_role_based_access?.some(
    (access) => access.label_id == 1 && access.label_value != 0
  );
  const taskPermission = user?.task_role_based_access?.some(
    (access) => access.label_id == 1 && access.label_value != 0
  );
  const quotationPermission = user?.quotation_role_based_access?.some(
    (access) => access.label_id == 1 && access.label_value != 0
  );

  return (
    <div>
      <ToastContainer />
      <Routes>
        <Route path="/crm/" element={<Login />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/crm/forgot/password" element={<ForgetPassword />} />
        <Route path="/crm/reset/password/:id" element={<ResetPassword />} />
        <Route path="/crm/task/priority" element={<ProtectedRoute element={<TaskPriority />} allowed={true} />} />
        <Route path="/crm/unauthorized" element={<Unauthorized />} />
        <Route path="/crm/customer" element={<ProtectedRoute element={<Customer />} allowed={customerPermission} />} />
        <Route path="/crm/lead_employees" element={<ProtectedRoute element={<LeadEmployees />} allowed={employeePermission} />} />
        <Route path="/crm/employee_work_related" element={<ProtectedRoute element={<EmployeeWorkRelated />} allowed={employeePermission} />} />
        <Route path="/crm/lead" element={<ProtectedRoute element={<Lead />} allowed={leadPermission} />} />
        <Route path="/crm/lead_task" element={<ProtectedRoute element={<LeadTask />} allowed={taskPermission} />} />
        <Route path="/crm/lead_dashboard" element={<LeadDashboard />} />
        <Route path="/crm/all_leads_task" element={<ProtectedRoute element={<AllLeadTask />} allowed={taskPermission} />} />
        <Route path="/crm/lead_status" element={<Status />} />
        <Route path="/crm/lead_source" element={<LeadSource />} />
        <Route path="/crm/lead_discussion_status" element={<DiscussionStatus />} />
        <Route path="/crm/quotation" element={<ProtectedRoute element={<Quotation />} allowed={quotationPermission} />} />
        <Route path="/crm/lead_role" element={<LeadRole />} />
        <Route path="/crm/lead_role_assign" element={<LeadRoleAssign />} />
        <Route path="/crm/quotation_status" element={<QuotationStatus />} />
        <Route path="/crm/task_status" element={<TaskStatus />} />
        <Route path="/crm/lead_branch" element={<LeadBranch />} />
        <Route path="/crm/lead_products" element={<LeadProducts />} />
        <Route path="/crm/product_report" element={<ProductwiseReport />} />
        <Route path="/crm/type-of-work" element={<TypeOfWork />} />

      </Routes>
    </div>
  );
}

export default App;
